import './component.scss'
import './images/arrow_down_icon.svg'
import '@splidejs/splide/css';
import { Splide } from '@splidejs/splide';
import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

import 'Components/refosumu/shared/no_company_image/component'

const app = Application.start()

app.register('refosumu-company-show-summary', class extends Controller {
  static targets = ["sliderPc", "sliderSp", "hiddenList", "toggleLink"]

  connect() {
    // window.load イベントを待ってから初期化
    if (document.readyState === 'complete') {
      this.initializeSliders()
    } else {
      window.addEventListener('load', () => {
        this.initializeSliders()
      })
    }
  }

  initializeSliders() {
    const PC_PER_PAGE = 1;
    const SP_PER_PAGE = 1;

    const SLIDER_CONFIGS = {
      pc: {
        speed: 800,
        perPage: PC_PER_PAGE,
        perMove: PC_PER_PAGE,
        gap: '8px',
        pagination: false,
        arrows: true,
      },
      sp: {
        speed: 800,
        perPage: SP_PER_PAGE,
        perMove: SP_PER_PAGE,
        gap: '12px',
        pagination: false,
        arrows: true,
        focus: 'center',
      }
    };

    // PC用スライダー初期化
    if (this.hasSliderPcTarget) {
      const pcSplide = new Splide(this.sliderPcTarget, SLIDER_CONFIGS.pc);
      pcSplide.mount();
    }

    // SP用スライダー初期化
    if (this.hasSliderSpTarget) {
      const spSplide = new Splide(this.sliderSpTarget, SLIDER_CONFIGS.sp);
      spSplide.mount();
    }
  }

  // アコーディオン機能（対応エリアの「もっと見る」）
  toggleServiceAreas(event) {
    event.preventDefault();

    const serviceArea = event.currentTarget.closest('.company-show-summary__service-area');
    const hiddenList = serviceArea.querySelector('.company-show-summary__service-area-list--hidden');
    const link = event.currentTarget;
    const textSpan = link.querySelector('.company-show-summary__service-area-more-link-text');

    if (hiddenList.classList.contains('hidden')) {
      hiddenList.classList.remove('hidden');
      textSpan.textContent = '閉じる';
      link.classList.add('expanded');
    } else {
      hiddenList.classList.add('hidden');
      textSpan.textContent = 'もっと見る';
      link.classList.remove('expanded');
    }
  }
})
